import React, { ReactNode } from "react";
import { AEDIcon } from "../../../assets/svg";

type CurrencyFormatBaseOptions = {
  formatStyle?: "currency" | "decimal";
  currency?: string;
  decimals?: number;
  showZero?: boolean;
  fallback?: string;
};

// Overload 1: returns ReactNode when withNewSymbol = true
export function currencyFormat(
  amount: number | string,
  options: CurrencyFormatBaseOptions & { withNewSymbol: true }
): ReactNode;

// Overload 2: returns string otherwise
export function currencyFormat(
  amount: number | string,
  options?: CurrencyFormatBaseOptions & { withNewSymbol?: false }
): string;

// Implementation
export function currencyFormat(
  amount: number | string,
  options: CurrencyFormatBaseOptions & { withNewSymbol?: boolean } = {}
) {
  const { formatStyle = "currency", currency = "AED", decimals = 0, showZero, fallback, withNewSymbol } = options;

  const value = Number(amount);

  if (isNaN(value)) return showZero ? (decimals === 0 ? "0" : `0.${"0".repeat(decimals)}`) : fallback;
  if (value === 0 && !showZero) return fallback;

  const formatted = new Intl.NumberFormat("en-US", {
    style: formatStyle,
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);

  // New AED symbol formatting
  if (formatStyle === "currency" && currency === "AED" && withNewSymbol)
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
        <AEDIcon />
        {formatted.replace(currency, "").trim()}
      </span>
    );

  return formatted;
}
